import Form from "../../componets/Form";

export default function Section8() {
  return (
    <Form />
  );
}
